import { useState } from 'react';

import { GridRenderCellParams } from '@mui/x-data-grid-premium';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import {
  buildDateObjectOrNull,
  formatDateDayStart,
} from '@sbv-clients/util-misc';

import {
  useWindowedTooltipZIndex,
  withWindowedPopperProps,
} from '../dialog/windowed-tooltip-zindex-context';

export const DataGridEditDateField = (props: GridRenderCellParams) => {
  const [open, setOpen] = useState(true);
  const value = buildDateObjectOrNull(props.value) as Date;
  const windowedConfig = useWindowedTooltipZIndex();
  return (
    <DatePicker
      open={open}
      value={value}
      onChange={(newValue) => {
        if (!props.hasFocus) return;
        setOpen(false);
        props.api.setEditCellValue({
          id: props.id,
          field: props.field,
          value: newValue
            ? props.colDef.type === 'date'
              ? new Date(newValue)
              : formatDateDayStart(newValue)
            : null,
        });
        props.api.stopCellEditMode({ id: props.id, field: props.field });
      }}
      slotProps={{
        textField: {
          variant: 'standard',
          InputProps: { disableUnderline: true },
        },
        popper: withWindowedPopperProps(windowedConfig, undefined),
      }}
    />
  );
};
